module.exports = __webpack_public_path__ + "static/img/video-popup-bg.292e324.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-popup-bg.jpg
// module id = mkET
// module chunks = 0